(function BuceDrawerUX(){
 'use strict';
 if(window.BuceDrawerUXV1)return;
 window.BuceDrawerUXV1={version:'20261014.1'};
 const drawerId='t4s-mini_cart';
 const allTabs=[
  {id:'accessories',label:'Accesorios'},
  {id:'shoes',label:'Zapatillas',small:'(de tu talla)'},
  {id:'shirts',label:'Camisetas'}
 ];
 let active='accessories';
 let scheduled=0,cartObserver=null,seenDrawer=null;
 let count=Number(document.querySelector('buce-v10-commerce')?.dataset.initialCount);
 if(!Number.isFinite(count))count=null;
 let addIntentExpires=0,toastTimer=0;

 function money(value){return String.fromCharCode(36)+Number(value).toLocaleString('es-CO');}
 function queue(){
  if(scheduled)return;
  scheduled=requestAnimationFrame(function(){scheduled=0;render();});
 }
 function isManualDrawerOpen(){
  const el=document.getElementById(drawerId);
  return !!el && (el.getAttribute('aria-hidden')==='false' || el.classList.contains('is--opened'));
 }
 function announce(){
  if(isManualDrawerOpen())return;
  let node=document.getElementById('buce-cart-add-toast');
  if(!node){
   node=document.createElement('div');
   node.id='buce-cart-add-toast';
   node.className='buce-cart-add-toast';
   node.setAttribute('role','status');
   node.setAttribute('aria-live','polite');
   node.setAttribute('aria-atomic','true');
   node.innerHTML='<span class="buce-cart-add-toast__mark" aria-hidden="true">✓</span><span>Agregado al carrito</span>';
   document.body.append(node);
  }
  clearTimeout(toastTimer);
  node.classList.add('is-visible');
  toastTimer=setTimeout(function(){node.classList.remove('is-visible');},1600);
 }
 function onClick(event){
  const target=event.target instanceof Element?event.target:null;
  if(!target||target.closest('#'+drawerId+',.t4s-cartPage__form'))return;
  const button=target.closest('button[name="add"],button[data-action-atc],button.t4s-product-form__submit,button[data-atc-form],.buce-quick-buy button[type="submit"],button[data-buce-cart-add],.t4s-pr-addtocart');
  if(!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
  addIntentExpires=Date.now()+10000;
 }
 function onSubmit(event){
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||form.closest('#'+drawerId+',.t4s-cartPage__form'))return;
  if(form.matches('form[action*="/cart/add"]'))addIntentExpires=Date.now()+10000;
 }
 function onCartStatus(event){
  const state=event.detail?.state,qty=Number(state?.dataset?.buceItemCount);
  if(Number.isFinite(qty)){
   if(count!==null&&qty>count&&Date.now()<addIntentExpires)announce();
   if(qty!==count)addIntentExpires=0;
   count=qty;
  }
  queue();
 }

 function tabsFor(group){
  let nav=group.querySelector(':scope > .buce-cart-tabs');
  if(!nav){
   nav=document.createElement('div');
   nav.className='buce-cart-tabs';
   nav.setAttribute('role','tablist');
   nav.setAttribute('aria-label','Completa tu compra');
   allTabs.forEach(function(item){
    const tab=document.createElement('button');
    tab.type='button';
    tab.className='buce-cart-tab';
    tab.dataset.buceTab=item.id;
    tab.setAttribute('role','tab');
    tab.setAttribute('aria-selected','false');
    const text=document.createElement('span');
    text.textContent=item.label;
    tab.append(text);
    if(item.small){const small=document.createElement('small');small.textContent=item.small;tab.append(small);}
    tab.addEventListener('click',function(){
     if(tab.disabled)return;
     active=item.id;
     updateGroup(group);
     const section=group.querySelector(':scope > section[data-buce-cart-rail="'+item.id+'"]');
     section?.querySelector('[data-buce-rail-track]')?.scrollTo({left:0,behavior:'auto'});
    });
    nav.append(tab);
   });
   const title=group.querySelector(':scope > h3');
   if(title)title.after(nav);
   else group.prepend(nav);
  }
  return nav;
 }
 function updateCards(group){
  group.querySelectorAll('article.buce-socks-nudge').forEach(function(card){
   const link=card.querySelector('.buce-socks-nudge__body>a');
   if(link&&!link.title)link.title=link.textContent.trim();
   const inBox=link&&/caja-protectora/i.test(link.href);
   if(card.dataset.buceBox!==String(!!inBox))card.dataset.buceBox=String(!!inBox);
   const btn=card.querySelector('button[data-buce-cart-add]');
   if(btn&&!btn.dataset.buceAddState&&btn.textContent.trim()!=='Agregar al carrito'){
    btn.textContent='Agregar al carrito';
   }
  });
 }
 function updateGroup(group){
  const nav=tabsFor(group);
  const sections=allTabs.map(function(t){return {tab:t,section:group.querySelector(':scope > section[data-buce-cart-rail="'+t.id+'"]')};});
  const available=sections.filter(function(o){
   if(!o.section)return false;
   if(o.tab.id==='shoes')return !o.section.hidden && !!o.section.querySelector('[data-buce-discovery-list] article');
   return !o.section.hidden && !!o.section.querySelector('.buce-cart-rail-track > article');
  }).map(function(x){return x.tab.id});
  if(!available.includes(active))active=available[0]||'accessories';
  sections.forEach(function(o){
   const btn=nav.querySelector('[data-buce-tab="'+o.tab.id+'"]');
   const activeTab=active===o.tab.id;
   const enabled=available.includes(o.tab.id);
   if(btn){
    btn.disabled=!enabled;
    btn.setAttribute('aria-selected',String(activeTab && enabled));
    btn.setAttribute('tabindex',activeTab && enabled?'0':'-1');
    btn.classList.toggle('is-current',activeTab&&enabled);
   }
   if(o.section){
    const inactive=!(activeTab&&enabled);
    if(o.section.dataset.buceTabInactive!==String(inactive))o.section.dataset.buceTabInactive=String(inactive);
   }
  });
  updateCards(group);
 }
 function updateProgress(drawer){
  const progress=drawer.querySelector('[data-buce-ah-progress]');
  if(!progress)return;
  let line=progress.querySelector('.buce-cart-next-step');
  if(!line){
   line=document.createElement('p');
   line.className='buce-cart-next-step';
   line.setAttribute('role','status');
   line.setAttribute('aria-live','polite');
   const track=progress.querySelector('.buce-ah-progress__segments');
   if(track)track.after(line);else progress.append(line);
  }
  const state=window.BuceAH&&typeof window.BuceAH.state==='function'?window.BuceAH.state():null;
  if(!state)return;
  const n=Math.max(0,Math.floor(Number(state.pairs)||0));
  const tiers={2:15000,3:25000,4:40000,5:50000};
  let message;
  if(n===0)message='Elige 2 pares: ahorra '+money(15000);
  else if(n>=1&&n<=4){
   const extra=tiers[n+1]-(tiers[n]||0);
   message='Agrega 1 par: +'+money(extra)+' de descuento';
  }
  else if(n===5)message='Agrega 1 par y llévate 1 gratis';
  else message=state.confirmed?'¡Par gratis aplicado!':'Beneficio por confirmar';
  if(line.textContent!==message)line.textContent=message;
 }
 function compactItems(drawer){
  drawer.querySelectorAll('[data-cart-items] .t4s-mini_cart__item').forEach(function(item){
   const qty=item.querySelector('.t4s-quantity-cart-item input[data-quantity-value]');
   const value=qty?.value;
   const marker=value==='1'?'1':'multiple';
   if(item.dataset.buceQty!==marker)item.dataset.buceQty=marker;
  });
 }
 function render(){
  const drawer=document.getElementById(drawerId);
  if(!drawer)return;
  if(seenDrawer!==drawer){
   if(cartObserver)cartObserver.disconnect();
   seenDrawer=drawer;
   cartObserver=new MutationObserver(function(records){
    const relevant=records.some(function(e){
     if(e.type==='attributes')return e.target.matches?.('[data-buce-discovery]');
     return Array.from(e.addedNodes).some(function(node){
      return node.nodeType===1 && (
       node.matches?.('[data-buce-v8-info],[data-buce-discovery-list],.buce-cart-complements,article.buce-socks-nudge') ||
       node.querySelector?.('[data-buce-discovery-list],.buce-cart-complements,article.buce-socks-nudge')
      );
     });
    });
    if(relevant)queue();
   });
   cartObserver.observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
  }
  const group=drawer.querySelector('[data-buce-v8-info] .buce-cart-complements');
  if(group)updateGroup(group);
  updateProgress(drawer);
  compactItems(drawer);
 }
 function start(){
  document.addEventListener('click',onClick,true);
  document.addEventListener('submit',onSubmit,true);
  document.addEventListener('buce:cart-status',onCartStatus);
  // Confirmacion inmediata para el Quick Buy; evitar duplicarla al refrescar cart-status.
  document.addEventListener('buce:quick-add-success',function(){
    announce();
    addIntentExpires=0;
  });
  document.addEventListener('buce:ah-state',queue);
  document.addEventListener('shopify:section:load',queue);
  document.addEventListener('buce:cart-error',function(){addIntentExpires=0;});
  const existing=document.getElementById(drawerId);
  if(existing)new MutationObserver(queue).observe(existing,{attributes:true,attributeFilter:['aria-hidden','class']});
  queue();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
 else start();
})();
